export const SWISS_FORMAT_LOCALE = 'de-CH';
